import request from "@/core/services/request";

export function login(phone, password) {
  return request({
    url: "/api/v1/user/login/",
    method: "post",
    data: {
      phone,
      password,
    },
  });
}

export function loginSms(phone, message) {
  return request({
    url: "/api/v1/user/login/sms/",
    method: "post",
    data: {
      phone,
      message,
    },
  });
}

export function verifyUser() {
  return request({
    url: "/api/v1/user/verify/",
    method: "get",
  });
}

export function getInfo() {
  return request({
    url: "/api/v1/instance/USER/",
    method: "get",
  });
}

export function logout() {
  return request({
    url: "/api/v1/user/logout/",
    method: "post",
  });
}
